<template>
  <div>
    <div class="modal_header">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24">
          <div class="grid-content bg-purple">
            <div class="title_h">
              {{ $t("message.update_nationality") }}
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24">
          <div class="grid-content bg-purple-light">
            <el-row class="button_r">
              <el-button
                type="success"
                :loading="loadingButton"
                :disabled="loadingButton"
                @click="submit(true)"
                >{{ $t("message.save_and_close") }}</el-button
              >
              <el-button @click="close()">{{ $t("message.close") }}</el-button>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="row" v-loading="loadingData">
      <div class="col-12 mt-2">
        <div class="modal-body">
          <el-form
              ref="form"
              status-icon
              :model="form"
              :rules="rules"
              :label-position="'left'"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item prop="name" :label="$t(`message.name`)">
                  <el-input v-model="form.name" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="start" :label="$t(`message.start`)">
                  <el-date-picker
                      v-model="form.start"
                      type="date"
                      :format="'yyyy-MM-dd'"
                      :value-format="'yyyy-MM-dd'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="end" :label="$t(`message.end`)">
                  <el-date-picker
                      v-model="form.end"
                      type="date"
                      :format="'yyyy-MM-dd'"
                      :value-format="'yyyy-MM-dd'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-select
                    v-model="selected_service"
                    filterable
                    clearable
                    class="w-100"
                >
                  <el-option
                      style="width: 500px"
                      v-for="service in inventory"
                      :key="service.id"
                      :value="service.id"
                      :label="service.name"
                  />
                </el-select>
              </el-col>
              <el-col :span="3">
                <el-button
                    @click="chooseService(selected_service)"
                    type="success"
                    class="w-100"
                >{{
                    $t(`message.choose`)
                  }}</el-button>
              </el-col>
            </el-row>
            <el-row :gutter="20" class="mt-3">
              <el-table border :data="services">
                <el-table-column label="№" prop="id" width="70" align="center"></el-table-column>
                <el-table-column :label="$t(`message.name`)" prop="name"></el-table-column>
                <el-table-column :label="$t(`message.price`)" prop="price" align="center" width="180"></el-table-column>
                <el-table-column :label="$t(`message.discount_price`)" width="180">
                  <template slot-scope="scope">
                    <el-input
                        v-model="scope.row.discount_price"
                        type="number"
                    />
                  </template>
                </el-table-column>
                <el-table-column :label="$t(`message.secondary_discount_price`)" width="180">
                  <template slot-scope="scope">
                    <el-input
                        v-model="scope.row.secondary_discount_price"
                        type="number"
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="delet" :label="$t(`message.delete`)" width="120">
                  <template slot-scope="scope">
                    <el-button
                        type="danger"
                        icon="el-icon-delete"
                        circle
                        @click="deleteService(scope.$index)"
                    />
                  </template>
                </el-table-column>
              </el-table>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import form from "@/utils/mixins/form";
import drawerChild from "@/utils/mixins/drawer-child";
import Currencies from "@/components/inventory-select/currencies.vue";
export default {
  components: {Currencies},
  mixins: [form, drawerChild],
  props: ["selected"],
  data() {
    return {
      loadingData: false,
      selected_service: null,
      services: [],
    };
  },
  computed: {
    ...mapGetters({
      rules: "promotions/rules",
      model: "promotions/model",
      columns: "promotions/columns",
      inventory: "services/inventory",
    }),
  },
  async mounted() {
    if (this.services && this.services.length === 0) await this.loadServices();
  },
  methods: {
    ...mapActions({
      save: "promotions/update",
      editModel: "promotions/show",
      empty: "promotions/empty",
      loadServices: "services/inventory",
    }),
    afterOpened() {
      if (this.selected && !this.loadingData) {
        this.loadingData = true;
        this.editModel(this.selected.id)
          .then(async (res) => {
            this.loadingData = false;
            this.form = JSON.parse(JSON.stringify(this.model));
            this.model.promotion_services.forEach(service => {
              this.services.push({
                id: service.id,
                name: service.service.name,
                price: service.price,
                discount_price: service.discount_price,
                secondary_discount_price: service.secondary_discount_price,
              });
            })
          })
          .catch((err) => {
            this.loadingData = false;
            this.$notify({
              title: 'Ошибка',
              type: "error",
              offset: 130,
              message: err
            });
          });
      }
    },
    afterClosed() {
      this.emptyForm();
    },
    loadModel() {
      this.form = JSON.parse(JSON.stringify(this.model));
    },
    submit(close = true) {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          this.form.services = JSON.parse(JSON.stringify(this.services))

          this.save(this.form)
            .then((res) => {
              this.loadingButton = false;
              this.$notify({
                title: 'Успешно',
                type: "success",
                offset: 130,
                message: res.message
              });
              this.parent().listChanged();
              this.emptyForm();
              this.close();
            })
            .catch((err) => {
              this.loadingButton = false;
              this.$notify({
                title: 'Ошибка',
                type: "error",
                offset: 130,
                message: err.error.message
              });
            });
        }
      });
    },
    chooseService(id) {
      const service = this.inventory.find(item => item.id === id);
      this.services.push({
        id: service.id,
        name: service.name,
        price: service.price,
        discount_price: 0,
      });
      this.selected_service = null;
    },
    deleteService(index) {
      this.services.splice(index, 1);
    },
    emptyForm() {
      this.empty();
      this.services = [];
    }
  },
};
</script>
